import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PaginatedList } from "@app/models/common/paginated-list.class";
import { EltonDiscrepancies, EltonSale, EltonSalesFilter, EltonSalesFilterOptions } from "@app/models/eltonsettlement/elton-discrepancies.model";
import { environment } from "@environments/environment";

@Injectable()
export class EltonSettlementService {

  private uri: string = `${environment.routes.apiEndpoint}/elton-settlement`;

  constructor(private http: HttpClient) { }

  getEltonDiscrepancies(dateFrom: Date | null = null, dateTo: Date | null = null, paymentReferenceId: string | null = null) {
    let filters = '';
    if (dateFrom != null) filters += `&dateFrom=${dateFrom.toISOString()}`;
    if (dateTo != null) filters += `&dateTo=${dateTo.toISOString()}`;
    if (paymentReferenceId != null) filters += `&providerReferenceId=${encodeURIComponent(paymentReferenceId)}`;
    return this.http.get<EltonDiscrepancies>(`${this.uri}/settlements/unverified?${filters}`);
  }

  getSales(
    filter: EltonSalesFilter,
    sortByField: string = 'completedAt',
    sortDescending: boolean = true,
    pageIndex: number = 1,
    pageSize: number = 100
  ) {
    let params = new HttpParams()
      .set('pageIndex', pageIndex)
      .set('pageSize', pageSize)
      .set('sortByField', sortByField)
      .set('sortDescending', sortDescending);

    filter.locationIds.forEach(id => params = params.append('locationIds', id));
    filter.cpos.forEach(cpo => params = params.append('cpos', cpo));
    filter.countries.forEach(country => params = params.append('countries', country));
    filter.cardTypes.forEach(cardType => params = params.append('cardTypes', cardType));
    filter.paymentMethods.forEach(method => params = params.append('paymentMethods', method));
    filter.customerTypes.forEach(type => params = params.append('customerTypes', type));
    if (filter.providerReferenceId) params = params.set('providerReferenceId', filter.providerReferenceId);
    if (filter.isPartiallyPaid !== null) params = params.set('isPartiallyPaid', filter.isPartiallyPaid);
    if (filter.completedAtFrom) params = params.set('completedAtFrom', filter.completedAtFrom.toISOString());
    if (filter.completedAtTo) params = params.set('completedAtTo', filter.completedAtTo.toISOString());
    if (filter.amountFrom !== null) params = params.set('amountFrom', filter.amountFrom);
    if (filter.amountTo !== null) params = params.set('amountTo', filter.amountTo);

    return this.http.get<PaginatedList<EltonSale>>(`${this.uri}/sales`, { params });
  }

  getSalesFilterOptions() {
    return this.http.get<EltonSalesFilterOptions>(`${this.uri}/sales/filter-options`);
  }

  acceptSaleManually(saleId: string, comment: string) {
    return this.http.post<void>(`${this.uri}/sales/${saleId}/accept-manually`, { comment });
  }
}
